// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ui.message{padding:16px}.ui.message .list:not(.ui) li{font-weight:700;margin-left:0}.ui.message .list:not(.ui) li:before{display:none}.ciam-error-tracking-id{font-weight:400;font-size:.8em;line-height:.8em}", ""]);
// Exports
module.exports = exports;
